import {
	Box,
	Button,
	Card,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	makeStyles,
	MenuItem,
	TextField,
	Typography,
	Link
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { hubConnection } from "signalr-no-jquery";
import ColorButton from "src/components/ColorButton";
import Split from "src/components/Split";
import LinkHiStatus, { HiConnectionState } from "./LinkHiStatus";
import { useHiDevice } from "src/context/HiDeviceContext";
import { use } from "react";
import { useTranslation } from "react-i18next";


let connection;
let hubProxy;
let time;

const useStyle = makeStyles(theme => {
	return {
		paper: {
			width: 1000,
			height: 600
		}
	};
});

const HiCommunicationState = {
	Undefined: 0,
	NoFittingDeviceAssigned: 1,
	RemoteHiAssigned: 2,
	NoRemoteHiAssigned: 3,
	CheckingFittingDevice: 4,
	OpenFittingDeviceFailed: 5,
	HiConnecting: 6,
	ConnectionCompleted: 7,
	ConnectionFailed: 8
};



const FittingDeviceOptions = [
	{
		label: "NoahLink",
		value: 1
	},
	{
		label: "HiPro",
		value: 2
	},
	{
		label: "Emulate",
		value: 3
	},
	{
		label: "RemoteLink",
		value: 4
	},
	{
		label: "NoahLinkWireless",
		value: 5
	}
];

let readyToBlur = false;
let readyToFocus = false;
let timeout = 500;

export default function LinkHI({
	close,
	isLinkHi = true,
	currentDeviceType,
	setCurrentDeviceType,
	hasPackage,
	leftStatus,
	setLeftStatus,
	rightStatus,
	setRightStatus,
	fittingDeviceConnectionStatus,
	setFittingDeviceConnectionStatus,
	training
}) {
	const classes = useStyle();
	const { connection: hiConnection, hubProxy: hiHubProxy } = useHiDevice();
	const { t } = useTranslation();
	const [message, setMessage] = useState({
		show: false,
		msg: ""
	});
	const LinkStatusState = {
		Unknown: -1,
		Disconnected: 0,
		Connecting: 1,
		Connected: 2,
	  };
	const [linkStatus, setLinkStatus] = useState(hasPackage ? LinkStatusState.Disconnected : LinkStatusState.Unknown); //-1,0,1

	const updateSideStatus = (sideData, setStatus) => {
		if (sideData) {
		  if (sideData.HiInfo) {
			setStatus({
			  state: sideData.ConnectionState,
			  data: sideData.HiInfo,
			  success: sideData.IsSuccess
			});
		  } else {
			setStatus({
			  state: HiConnectionState.Failed,
			  data: null,
			  success: false
			});
		  }
		}
	  };
	const handleClose = () => {
		close();
	};

	const handleChangeDevice = e => {
		setCurrentDeviceType(e.target.value);
	};
	const DownloadPanel = () => {
		return (
			<Card style={{ height: "100%" }}>
				<Typography variant="h4" component="h4">
				{t('connection.cannotConnect')}
				</Typography>
				<Box textAlign="center">
					<Button
						href="https://dolphinsound.net.cn/HIClientRelease/HiConnector.exe"
						color="primary"
						variant="contained"
					>
						{t('connection.downloadInstaller')}
					</Button>
				</Box>
				<Typography
					variant="h6"
					component="h6"
					style={{ textAlign: "center", marginTop: 24 }}
				>
					{t('connection.installedClientTip')} <Link href="dolphinsound://">{t('connection.openClient')}</Link>
					, {t('connection.cannotConnect')}，<Link href="#">{t('connection.checkReason')}</Link>
				</Typography>
			</Card>
		);
	};
	const renderContent = () => {
		if (isLinkHi && linkStatus !== LinkStatusState.Unknown) {
			return (
				<Split
					defaultIsDivided={true}
					leftData={leftStatus}
					rightData={rightStatus}
					style={{
						height: "calc(100% - 48px)"
					}}
				>
					<LinkHiStatus />
				</Split>
			);
		}
		if (
			!isLinkHi &&
			fittingDeviceConnectionStatus.status >= 1 &&
			!message.show
		) {
			if (fittingDeviceConnectionStatus.status === 2)
				return (
					<Box>
						<Alert severity="error" variant="outlined">
							编程设备连接失败
						</Alert>
						<TextField
							className={classes.deviceSelect}
							label="编程设备"
							name="device"
							select
							variant="outlined"
							size="medium"
							style={{
								width: "50%",
								margin: "50px 0"
							}}
							value={currentDeviceType}
							onChange={handleChangeDevice}
						>
							{FittingDeviceOptions.map(item => (
								<MenuItem key={item.value} value={item.value}>
									{item.label}
								</MenuItem>
							))}
						</TextField>
						<Typography variant="h5" component="h5">
						{t('connection.device.tip')}
						</Typography>
					</Box>
				);
			else
				return (
					<Alert severity="success" variant="outlined">
						{t('connection.device.connectSuccess')}
					</Alert>
				);
		}
	};
	const renderDialogContent = () => {
		console.log("linkStatus", linkStatus);
		console.log("message", message);
		console.log("isLinkHi", isLinkHi);
		switch (linkStatus) {
			case -1:
				return <DownloadPanel />;
			case 0:
				return <Card style={{ height: "100%" }}>{t('connection.connecting')}</Card>;
			default:
				return (
					<Card style={{ height: "100%" }}>
						{message.show && (
							<Alert severity="info" variant="outlined">
								{isLinkHi ? message.msg : t('connection.checkingDevice')}
							</Alert>
						)}
						{renderContent()}
					</Card>
				);
		}
	};

	const startConection = (isFirst = true) => {
		// connect
		connection
			.start()
			.done(function() {
				setLinkStatus(LinkStatusState.Connecting);
				console.log(training);
				console.log("Now connected, connection ID=" + connection.id);
				detectAndConnectHi();
			})
			.fail(function() {
				console.log("连接失败");
				if (isFirst) {
					/* eslint-disable-next-line no-restricted-globals */
					location.href = "dolphinsound://";
					readyToBlur = true;
					time = setTimeout(function() {
						readyToBlur = false;
						clearTimeout(time);
						setLinkStatus(LinkStatusState.Unknown);
					}, timeout);
				} else {
					setLinkStatus(LinkStatusState.Unknown);
				}
			});
	};

	const detectAndConnectHi = () => {
		!message.show &&
			hubProxy &&
			hubProxy.invoke("DetectAndConnectHi", currentDeviceType);
	};

	const reTry = () => {
		detectAndConnectHi();
	};

	useEffect(() => {
		if (!hasPackage) return;
		setLinkStatus(LinkStatusState.Disconnected);
		if (!connection) {
			connection = hiConnection;
			hubProxy = hiHubProxy;
			hubProxy.on("getResult", function(res) {
				console.log(res);
				if (
					res.data.CommunicationState >= 0 &&
					res.data.CommunicationState < HiCommunicationState.ConnectionCompleted
				) {
					setMessage({ show: true, msg: res.msg });
				}
				setFittingDeviceConnectionStatus({
					msg: res.msg,
					status: res.data.FittingDeviceConnectionState,
					success: res.success
				});

				if (!isLinkHi) {
					if (
						res.data.CommunicationState > 0 &&
						res.data.FittingDeviceConnectionState >= 1
					) {
						setMessage({ show: false, msg: res.msg });
						hubProxy.off("getResult");
					}
					return;
				}
				if (res?.data.Left?.HiInfo || res?.data.Right?.HiInfo) {
					setMessage({ show: true, msg: res.msg });
					setLinkStatus(LinkStatusState.Connected);
				}
				if (res?.data.Left) {
					updateSideStatus(res?.data.Left, setLeftStatus);
				}

				if (res?.data.Right) {
					updateSideStatus(res?.data.Right, setRightStatus);
				}

				if (
					res.data.CommunicationState ===
						HiCommunicationState.ConnectionCompleted ||
					res.data.CommunicationState === HiCommunicationState.ConnectionFailed
				) {
					setMessage({ show: false, msg: res.msg });
				}
			});
			startConection();
		} else {
			setLinkStatus(LinkStatusState.Connecting);
			detectAndConnectHi();
		}

		return () => {
			hubProxy.off("getResult");
			connection.stop();
			connection = null;
		};
	}, []);

	const callback = () => {
		if (readyToBlur) {
			readyToFocus = true;
			readyToBlur = false;
			t && clearTimeout(t);
			setLinkStatus(LinkStatusState.Disconnected);
		}
	};
	const foucsCallback = () => {
		if (readyToFocus) {
			readyToFocus = false;
			if (connection) startConection(false);
		}
	};

	useEffect(() => {
		window.addEventListener("blur", callback);
		window.addEventListener("focus", foucsCallback);
		return () => {
			window.removeEventListener("blur", callback);
			window.removeEventListener("focus", foucsCallback);
		};
	}, []);

	return (
		<Dialog
			onClose={handleClose}
			aria-labelledby="simple-dialog-title"
			open={true}
			maxWidth="md"
			classes={{
				paper: classes.paper
			}}
		>
			<DialogTitle id="link-hi">{t('connection.title')}</DialogTitle>
			<DialogContent>{renderDialogContent()}</DialogContent>
			<DialogActions>
				<Button
					color="primary"
					variant="contained"
					onClick={reTry}
					disabled={message.show}
				>
					{t('connection.retry')}
				</Button>
				<Button
					color="primary"
					variant="contained"
					autoFocus
					onClick={handleClose}
				>
					{t('connection.confirm')}
				</Button>
				<ColorButton
					type="danger"
					color="primary"
					variant="contained"
					onClick={handleClose}
				>
					{t('connection.cancel')}
				</ColorButton>
			</DialogActions>
		</Dialog>
	);
}
